import React from 'react';
import site from '../../data/site';

const STEPS = [
    {
        title: 'Reach out',
        text: 'Call the office or request a callback. You don’t need to share your full story in the website form.',
    },
    {
        title: 'Talk with intake',
        text: 'Discuss your needs, confirm service availability, and check your insurance benefits or payment options.',
    },
    {
        title: 'Prepare for your appointment',
        text: 'The team explains what to bring and how to complete any required intake documents securely.',
    },
    {
        title: 'Build your care plan',
        text: 'Meet with a clinician to understand your needs and discuss appropriate next steps together.',
    },
];

const listInsurance = (plans) => `${plans.slice(0, -1).join(', ')}, and ${plans[plans.length - 1]}`;

const FirstVisit = () => (
    <div id="start" className="sw-visit">
        <div className="sw-container sw-visit__inner">
            <div className="sw-visit__copy">
                <p className="sw-eyebrow">Your first visit</p>
                <h2 className="sw-heading sw-visit__title">Getting started should<br/>feel manageable.</h2>
                <p className="sw-visit__lede">
                    You can ask questions before committing to care. An appointment request begins a
                    conversation with the intake team.
                </p>
                <div className="sw-visit__info">
                    <h3>Insurance &amp; payment</h3>
                    <p>
                        We accept {listInsurance(site.insurance)}. Contact intake to verify your specific plan,
                        benefits, and any out-of-pocket costs before your visit.
                    </p>
                </div>
            </div>
            <div className="sw-visit__steps">
                {STEPS.map((step, index) => (
                    <div key={step.title} className="sw-visit__step">
                        <b>{index + 1}</b>
                        <div>
                            <h3>{step.title}</h3>
                            <p>{step.text}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default FirstVisit;
